import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home.vue'
import Document from '@/views/document.vue'
import Browse from '@/views/browse.vue'
import Search from '@/views/search.vue'
import InferCell from '@/views/infer_cell.vue'
import EMIC from '@/views/emic.vue'
import Download from '@/views/download.vue'
import PhenotypeTaskResult from '@/views/results/phenotype_task.vue'
import EMICTaskResult from '@/views/results/common_task_emic.vue'
import PhenotypeResult from '@/views/results/phenotype.vue'
import CellResult from '@/views/results/cell.vue'
import GeneResult from '@/views/results/gene.vue'
import Contact from '@/views/contact.vue'

import admin from '@/views/admin/index.vue'

import test from '@/components/test/test.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/infer_cell',
      name: 'infer_cell',
      component: InferCell,
    },
    {
      path: '/emic',
      name: 'emic',
      component: EMIC,
    },
    {
      path: '/results/phenotype_task',
      name: 'task-result_phenotype',
      component: PhenotypeTaskResult,
    },
    {
      path: '/results/common_task_emic',
      name: 'task-emic',
      component: EMICTaskResult,
    },
    {
      path: '/results/phenotype',
      name: 'result_phenotype',
      component: PhenotypeResult,
    },
    {
      path: '/results/cell',
      name: 'result_cell',
      component: CellResult,
    },
    {
      path: '/results/gene',
      name: 'result_gene',
      component: GeneResult,
    },
    
    {
      path: '/document',
      name: 'doucument',
      component: Document,
    },
    {
      path: '/browse',
      name: 'browse',
      component: Browse,
      meta: {  
        keepAlive: 'true',
        isBack: false,
        }  
    },   
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta: {  
        keepAlive: 'true',
        isBack: false,
        }  
    },    

    {
      path: '/download',
      name: 'download',
      component: Download,
    },
    
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },

    {
      path: '/test',
      name: 'test',
      component: test,
    },

    {
      path: '/oa/admin',
      name: 'admin',
      component: admin,
    }
  ],
  assetsPublicPath: '/ibms/'
})



// WEBPACK FOOTER //
// ./src/router/index.js